<template>
    <div>
        <div class="side-by-side" v-for="(item, index) in actions" :key="index">

            <Button v-if="item.type === 'delete'" tooltip="Gerar Retorno" key="remove" classIcon="fa-solid fa-trash"
                :title="item.title" type="danger" size="small" :params="item" :clicked="() => $emit('confirm', item)" />

            <Tooltip :title="item.tooltip">
                <Button v-if="item.type === 'component'" key="component" :title="item.title" :classIcon="item.classIcon"
                    :type="item.backgroundColor ? '' : 'primary'" size="small" :params="item" color="white"
                    :backGroundColor="item.backgroundColor ? item.backgroundColor : ''"
                    :clicked="() => $emit('confirm', item)" />
            </Tooltip>

            <Tooltip :title="item.tooltip">
                <Button v-if="item.type === 'options'" key="options" :title="item.title" :classIcon="item.classIcon"
                    :type="item.backgroundColor ? '' : 'primary'" size="small" :params="item" color="white"
                    :backGroundColor="item.backgroundColor ? item.backgroundColor : ''"
                    :clicked="() => $emit('confirm', item)" />
            </Tooltip>

            <Tooltip :title="item.tooltip">
                <Button v-if="item.type === 'event'" :eventName="item.eventName" key="event" :title="item.title"
                    :classIcon="item.classIcon" :type="item.backgroundColor ? '' : 'primary'" size="small"
                    :params="item" color="white" tooltip="Gerar Retorno"
                    :backGroundColor="item.backgroundColor ? item.backgroundColor : ''" />
            </Tooltip>

        </div>
    </div>
</template>

<script>
import Button from "@/ui/forms/Button";
import Tooltip from "@/ui/layout/Tooltip";

import { mapMutations } from "vuex";

export default {
    name: "ActionButtons",
    components: { Button, Tooltip },
    props: {
        actions: { type: Array, default: () => [] },
    },
    methods: {
        ...mapMutations("generic", ["addEvent"]),
    }
};
</script>

<style scoped></style>
